import { render } from "./SmsStatusButton.vue?vue&type=template&id=07224b04&scoped=true"
import script from "./SmsStatusButton.vue?vue&type=script&lang=js"
export * from "./SmsStatusButton.vue?vue&type=script&lang=js"

import "./SmsStatusButton.vue?vue&type=style&index=0&id=07224b04&lang=scss&scoped=true"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07224b04"]])

export default __exports__